import { memo } from 'react';

const CheckWork = ({ className, color = "#007CC3", opacity = 0.5 }) => {
    return (
        <span className={className} style={{ color, opacity }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect 
                    x="0.5" 
                    y="0.5" 
                    width="23" 
                    height="23" 
                    rx="3.5" 
                    stroke="currentColor" 
                />
                <path 
                    d="M3 14.5L8.425 19L20.5 6.92505" 
                    stroke="currentColor" 
                    strokeWidth="2" 
                />
            </svg>
        </span>
    );
};
export default memo(CheckWork);